import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import { t } from "i18next";
import React, { useState } from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
const useStyles = makeThemedStyles("RejectionModal.styles", (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "20px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: "3.657em 3.657em 2.17em",
    borderRadius: "2.97em",
    width: "48.68em",
    height: "40.34em",
    background: "rgba(255, 255, 255, 0.9)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  headIcon: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "rgba(76, 81, 87, 1)",
    margin: "0.8333em 0px",
  },
  textroot: {
    width: "42.97em",
    borderColor: "rgba(209, 213, 219, 1)",
  },
  bottomBtn: {
    marginTop: "4.11em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  btncancel: {
    width: "9.37em",
    height: "3.125em",
    borderRadius: "2.5em",
    "&:hover": {
      background: "none",
    },
  },
  btnreject: {
    background: "rgba(0, 169, 163, 1)",
    width: "9.37em",
    height: "3.125em",
    borderRadius: "2.5em",
    "&:hover": {
      backgroundColor: "rgb(0, 169, 163, 0.7)",
    },
  },
  btnlabel: {
    textTransform: "none",
  },
}));
const RejectionModal = (props: {
  visible: boolean;
  handleShow: (stat: boolean) => void;
  sendMsg: (msg: string) => void;
}) => {
  const classes = useStyles();
  const { visible, handleShow } = props;
  const { language: lang, rtl } = useAppContext((state) => state);
  const [message, setmessage] = useState("");
  const handlevisible = () => {
    handleShow(!visible);
  };
  return (
    <Modal
      style={{ zIndex: "99999" }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={visible}
      dir={rtl ? "rtl" : "ltr"}
      onClose={handlevisible}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={visible}>
        <div className={classes.paper}>
          <div className={classes.headIcon}>
            <InfoOutlinedIcon fontSize="large" htmlColor="rgba(189, 41, 44)" />
          </div>
          <h2 className={classes.title} id="transition-modal-title">
            {t("Rejection cause prompt")}
          </h2>
          <TextField
            id="outlined-multiline-static"
            multiline
            rows={4}
            className={classes.textroot}
            defaultValue="Default Value"
            variant="outlined"
            value={message}
            InputProps={{
              style: {
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "20px",
                borderRadius: "0.6em",
              },
            }}
            onChange={(e) => setmessage(e.target.value)}
          />
          <div className={classes.bottomBtn}>
            <Button
              variant="contained"
              style={{
                marginLeft: rtl ? "6px" : "0px",
                marginRight: rtl ? "0px" : "6px",
                background: "rgba(238, 243, 244, 1)",
                fontSize: "16px",
                boxShadow: "none",
                color: "rgba(17, 94, 103)",
                lineHeight: "27px",
              }}
              onClick={() => handlevisible()}
              classes={{ root: classes.btncancel, label: classes.btnlabel }}
              color="primary"
            >
              {t("Cancel")}
            </Button>
            <Button
              variant="contained"
              style={{
                fontSize: "16px",
                color: "#fff",
                boxShadow: "none",
                lineHeight: "27px",
                marginLeft: rtl ? "0px" : "6px",
                marginRight: rtl ? "6px" : "0px",
              }}
              onClick={() => props.sendMsg(message)}
              classes={{ label: classes.btnlabel }}
              className={`${classes.btnreject}`}
              color="primary"
            >
              {t("Send Rejection")}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
export default RejectionModal;
